export default __webpack_public_path__ + "static/media/photo--lg--ish-3.b8a4bc63.jpg";